/*
 * @Author: cc
 * @Date: 2020-01-08 21:23:14
 * @LastEditTime : 2020-01-08 22:19:47
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\app\appPart.js
 * @Description:App渠道编辑页专用指令集合
 */
angular
    .module('AppeditPageModule', [
        'AppListInfoModule', // 列表信息部分
        'AppAttrInfoModule', // 稿件属性信息模块
        'AppCommentModule', // 点赞、评论设置
        'AppOtherInfoModule', // 稿件其他信息
    ])
    .controller('AppeditPageCtrl', ['$scope', function($scope) {}]);
